export enum ResubmissionStatusEnum {
	Unknown = 0,
	DocumentUnderReview = 1,
	DocumentReject = 2,
	DocumentApproved = 3
}
